import React, { useContext } from "react";
import { Button, Grid, TextField } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import AuthService from "../../../services/auth.service";
import GlobalContext from "../../../state/GlobalContext";
import PulseLoader from "react-spinners/PulseLoader";
import { colors } from "../../../assets/theme";
import { useAlert } from "react-alert";
import { constantsApp } from "../../../constants/constants.app";

const signinSchema = Yup.object().shape({
  email: Yup.string()
    .email(
      constantsApp.components.forms.accounts.signIn.signInSchema.INVALID_EMAIL
    )
    .required(
      constantsApp.components.forms.accounts.signIn.signInSchema.REQUIRED
    ),
  password: Yup.string()
    .min(6)
    .required(
      constantsApp.components.forms.accounts.signIn.signInSchema.REQUIRED
    )
});

export default function SignIn() {
  const { session } = useContext(GlobalContext);
  const alert = useAlert();
  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={signinSchema}
      onSubmit={(values, { setSubmitting }) => {
        AuthService.login(values.email, values.password)
          .then(user => {
            setSubmitting(false);
            session.dispatch({
              type: "LOGIN",
              payload: { user }
            });
          })
          .catch(err => {
            setSubmitting(false);
            alert.show(err.message, { type: "error" });
          });
      }}
    >
      {({ errors, handleChange, handleSubmit, values, isSubmitting }) => {
        if (isSubmitting)
          return (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: 200 }}
            >
              <PulseLoader color={colors.LOADING} />
            </Grid>
          );

        return (
          <form onSubmit={handleSubmit}>
            <TextField
              id="email"
              onChange={handleChange}
              value={values.email}
              variant="outlined"
              margin="dense"
              fullWidth
              type="email"
              placeholder={
                constantsApp.components.forms.accounts.signIn.textFields
                  .EMAIL_PH
              }
              helperText={errors && errors.email}
            />
            <TextField
              id="password"
              onChange={handleChange}
              value={values.password}
              variant="outlined"
              margin="dense"
              fullWidth
              type="password"
              placeholder={
                constantsApp.components.forms.accounts.signIn.textFields
                  .PASSWORD_PH
              }
              helperText={errors && errors.password}
            />
            <Grid container justify="center">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.LOGIN}
              </Button>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
}
